import React from 'react';
import moment from 'moment';

interface DateProps {
  value?: string;
}

const Date = ({ value }: DateProps) => {
  return <>{moment(value).format('D. M. YYYY')}</>;
};

export default Date;
